import { Validator } from 'vee-validate'
import { resolveDate } from '@/common/services/ResolveDate'

Validator.extend('select', {
	getMessage: field => 'Le champ ' + field + ' doit être rempli',
	validate: (value, isObject) => {
		const test = (isObject[0]) ? value.type : value
		return (test !== null && test !== undefined && test.trim() !== '' && test.trim() !== '-')
	}
})

Validator.extend('canbenullif', {
	getMessage: field => 'Le champ ' + field + ' doit être rempli',
	validate: (value, args) => {
		return (args[0] === 'true') ? true : (value !== null && value !== undefined && value.trim() !== '')
	}
})

Validator.extend('min_date', {
	getMessage: field => 'La ' + field + ' doit être supérieur à aujourd\'hui ou à la date de début',
	validate: (value, args) => {
		if (value && resolveDate(value)) {
			console.log(value, args)
			return resolveDate(value).split('-').reverse().join('-') >= resolveDate(args[0]).split('-').reverse().join('-')
		} else {
			return false
		}
	}
})



// WEBPACK FOOTER //
// ./src/common/services/ExtendRules.js